import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  display: flex;
  background: linear-gradient(90deg, #006644 0%, #00a884 50%, #03a9f4 100%);
  //background: linear-gradient(90deg, #01579b 0%, #03a9f4 100%);
  //background: linear-gradient(232deg, #03a9f4 17.72%, #48ab17 100%);
  color: #ffffff;
  min-height: 54px;
  font-size: 14px;
  line-height: 32px;
  box-shadow: var(--box-shadow-level-1);
  z-index: var(--z-index-30);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const ColumnLeft = styled.div`
  display: flex;
`;

export const SRightSection = styled.div`
  display: flex;
  width: 94%;
  justify-content: space-between;
  align-items: center;
`;

export const SGitInfo = styled.div`
  display: flex;
  align-items: center;
  font-size: 11px;
  padding-left: 25px;
`;
